import { render, staticRenderFns } from "./DocMarkup.vue?vue&type=template&id=b1e3f200&"
import script from "./DocMarkup.vue?vue&type=script&lang=js&"
export * from "./DocMarkup.vue?vue&type=script&lang=js&"
import style0 from "./DocMarkup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VIcon,VSlideXTransition})
